import { Tag } from "antd";
import { ReactElement } from "react";
import { TagSignProps } from "../../../../../interfaces/props/TagSignProps";

export function TagSign({ tag }: TagSignProps): ReactElement {
  if (tag === "sign_true") {
    return <Tag color="green">Подписано клиентом</Tag>;
  } else if (tag === "sign_false") {
    return <Tag color="red">Без подписи</Tag>;
  }

  return <Tag>Документ не загружен</Tag>;
}
